import Axios, { InternalAxiosRequestConfig } from "axios";

import { env } from "@blueskydataplatform/shared-ui/config/env";
import Cookies from "js-cookie";

export interface RedirectResponse {
  redirect?: boolean;
  redirected?: boolean;
  url?: string;
}

export const authApi = Axios.create({
  baseURL: env.AUTH_API_URL,
  validateStatus: (status: number) => status >= 200 && status < 400,
});

export const authApiWithAuth = Axios.create({
  baseURL: env.AUTH_API_URL,
  validateStatus: (status: number) => status >= 200 && status < 400,
});


function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.method && config.method.toUpperCase() !== "GET" && config.method.toUpperCase() !== "HEAD") {
    config.headers.set("ctoken", Cookies.get("ctoken"));
    if (config.data) {
      config.data = {
        ...config.data,
        _ctoken: Cookies.get("ctoken"),
      };
    }
  }
  return config;
}

authApiWithAuth.interceptors.request.use(authRequestInterceptor);

authApi.interceptors.request.use(authRequestInterceptor);


